import { render, staticRenderFns } from "./CkContent.vue?vue&type=template&id=0168e400&scoped=true&"
import script from "./CkContent.vue?vue&type=script&lang=js&"
export * from "./CkContent.vue?vue&type=script&lang=js&"
import style0 from "@/style/ck-content.css?vue&type=style&index=0&lang=css&"
import style1 from "./CkContent.vue?vue&type=style&index=1&id=0168e400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0168e400",
  null
  
)

export default component.exports